import { useState } from 'react';
import { Stack } from '@mui/material';

import DefaultWrapper from 'shared-components/DefaultWrapper';
import { CareList, SearchField, Title } from 'components/AddCareCenter';
import { Content } from './styles';
import { useListDetailedCareCenters, useRedirectCareCenter } from 'hooks/MyCareNetwork/AddCareCenter';
import { BasicSkeleton } from 'components/SkeletonLoaders';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { useGetProfileParticipantTasksQuery } from 'store/api/pkd/endpoints/participantTask';
import { useListConnectedCareCenters } from 'hooks/MyCareNetwork';

const AddCareCenter = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const handleChange = (event) => setSearchTerm(event.target.value);
  const { connectedCareCenters, isLoading: isConnectedCareCentersLoading } = useListConnectedCareCenters();
  const { isLoading: isListDetailedCareCenterLoading, searchCareCenters } = useListDetailedCareCenters();
  const [redirectCareCenter, { isLoading: isRedirectCareCenterLoading }] =
    useRedirectCareCenter();
  const [searchResults, setSearchResults] = useState([]);
  const [searchAttempted, setSearchAttempted] = useState(false);
  const { personAccountProfileId, personId, isPersonLoading } = useGetPersonAndAttributes();
  const { data: participantTasks = [], isFetching: isTasksLoading } = useGetProfileParticipantTasksQuery(
    { personAccountProfileId },
    { skip: !personAccountProfileId }
  );

  const participantTaskId = participantTasks.find(
    (task) => task.code === 'SEHR'
  )?.id;

  const crumbs = [
    { title: 'My Care Network', isActive: false, linkTo: '/my-care-network' },
    { title: 'Add Care Center', isActive: true },
  ];

  const handleSearch = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 4) return;
    if (!personId) return;
    setSearchAttempted(true);
    const results = await searchCareCenters(searchTerm, personId, participantTaskId);
    setSearchResults(results);
  };

  const handleClearInput = () => {
    setSearchTerm('');
    setSearchResults([]);
    setSearchAttempted(false);
  };
  const connectedIds = connectedCareCenters?.reduce((acc, cc) => {
    const id = cc?.attributes?.healthSystemId;
    if (id) {
      acc.push(id);
    }
    return acc;
  }, []);

  return (
    <DefaultWrapper
      crumbs={crumbs}
      showHeader={true}
      margin={{ xs: '10px 18px 0px 18px', lg: '10px 78px 0px 78px' }}>
      <Content
        marginRight={{ xs: '20px', md: '150px', xl: '0' }}
        marginLeft={{ xs: '20px', md: '150px', xl: '0' }}>
        <Title
          sx={{ md: { padding: '150px' } }}>My Care Network</Title>
        {isRedirectCareCenterLoading || isPersonLoading || isTasksLoading || isConnectedCareCentersLoading
          ? (
            <BasicSkeleton
              height='86px'
            />
          )
          : (
            <Stack
              spacing='30px'
              sx={{ padding: '15px' }}>
              <SearchField
                value={searchTerm}
                onChange={handleChange}
                onClear={handleClearInput}
                participantTaskId={participantTaskId}
                personId={personId}
                onSearch={handleSearch}
              />
              <CareList
                careCenters={searchResults}
                isListDetailedCareCenterLoading={isListDetailedCareCenterLoading}
                enrolledIds={connectedIds}
                searchTerm={searchTerm}
                searchAttempted={searchAttempted}
                onClickCareCenter={redirectCareCenter}
              />
            </Stack>
          )}
      </Content>
    </DefaultWrapper>
  );
};

export default AddCareCenter;
